<template>
    <FormInputContainer :inputId="`I${_uid}`" :label="label" :errors="errors">
        <textarea
            :id="`I${_uid}`"
            v-bind="$attrs"
            :value="value"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormTextarea',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: String },
        label: { type: String },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
    },

    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
textarea {
    @extend %form-control;

    height: auto;
    line-height: 1.4;
    padding: 10px 15px;
    resize: vertical;
}
</style>
